export const staticRoutes = {
  static_routes: "static_routes",
  route_private: "SRoutePrivate",
  route_active: "SRouteActive",
  route_dest_addr: "SRouteDestAddr",
  route_subnet: "SRouteSubnetMask",
  route_gateway_addr: "SRouteGatewayAddr",
};

export default staticRoutes;
